module.exports = __webpack_public_path__ + "img/escaperoom_01.3d266374.jpg";